import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppSettings } from '../../app-settings';
import { SidePanelCard } from '../../models/side-panel-card';
import { SidePanelService } from '../../Services/side-panel.service';
import { SessionService } from './../../Services/session.service';

@Component({
  selector: 'app-marketing-message',
  templateUrl: './marketing-message.component.html',
  styleUrls: ['./marketing-message.component.css'],
  animations:[
    trigger('slideInOut', [
      state('in', style({
        height: '*'
      })),
      state('out', style({
        opacity: '0',
        overflow: 'hidden',
        height: '0px'
      })),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ]),
    trigger("webinarInOut", [
      state(
        "collapsed",
        style({

        })
      ),
      state(
        "expanded",
        style({
          display: 'none'
        })
      ),
      transition("expanded <=> collapsed", animate("500ms linear")),
    ])
  ]
})
export class MarketingMessageComponent implements OnInit, OnDestroy {

  @HostListener('window:resize', ['$event'])
onResize(event) {
  this.screenSize=event.target.innerWidth;
}

  constructor(private sidePanelService: SidePanelService, private sessionService: SessionService, private route: ActivatedRoute) {

  }

  cards: SidePanelCard[] = [];
  screenSize:number;
  webPlus = AppSettings.cdnUrl + "assets/images/web_plus.png";
  webMinus = AppSettings.cdnUrl + "assets/images/web_minus.png";
  liveWebinarIcon = AppSettings.cdnUrl + "assets/images/live_webinar_icon.png"
  marketingExpand:boolean = true;
  helpMenuOpen: string = "in";
  levelsState = "collapsed";
  pageName = '';
  private cardsSubscription: Subscription;

  ngOnInit()
  {
      this.screenSize=window.innerWidth;
      if(this.screenSize<=868)
      {
        this.marketingExpand = false;
        this.helpMenuOpen = "out";
      }
      else
      {
        this.marketingExpand = true;
        this.helpMenuOpen = "in";
      }

      this.sessionService.levelCollapsed.subscribe(state => {
        this.levelsState = state;
        if(this.screenSize <= 991)
        {
          this.levelsState = 'collapsed';
        }
      });

      this.sessionService.getPageName.subscribe((pageName) => {
        const currentPage = pageName.length > 0 ? pageName : this.route.snapshot.paramMap.get('page');
        if (currentPage !== this.pageName) {
          this.pageName = currentPage;
          this.loadCards();
        }
      });

  }

  ngOnDestroy() {
    if (this.cardsSubscription) {
      this.cardsSubscription.unsubscribe();
    }
  }

  loadCards() {
    if (this.cardsSubscription) {
      this.cardsSubscription.unsubscribe();
    }
    this.cardsSubscription = this.sidePanelService.getCards(this.pageName)
      .subscribe(cards => this.cards = cards);
  }

showWebinars()
{
  this.marketingExpand = !this.marketingExpand;
  this.helpMenuOpen = this.helpMenuOpen === 'out' ? 'in' : 'out';
}

expandWebinarContainer() {
  if(this.levelsState === "expanded"){
    this.sessionService.updateWebinarComponentState("expanded");
  }

}

}
